import * as React from 'react'
import { observer } from 'mobx-react'
import BusinessInfoViewModel from './../BusinessInfoViewModel'

import { Section, SectionItem } from '../../components/Section'
import { PhysicalAddressSectionItems } from 'jobs/info-gathering/components/PhysicalAddress'

interface Props {
  vm: BusinessInfoViewModel
}

export default observer(function BusinessInfo({ vm }: Props) {
  return (
    <div>
      <Section title="Business Information" loading={vm.activate.pending}>
        <SectionItem
          label="Business name"
          value={vm.profile?.businessInfo?.businessName}
        />

        <SectionItem
          label="Date of incorporation"
          value={vm.profile?.businessInfo?.dateOfIncorporation}
        />

        <SectionItem
          label="Employer identification number (EIN)"
          value={vm.profile?.businessInfo?.employerIdentificationNumber}
          maskedValue={
            vm.profile?.businessInfo?.employerIdentificationNumberDisplay
          }
          isSensitive
        />
      </Section>

      <Section title="Contact Information" bordered>
        <PhysicalAddressSectionItems vm={vm.profile?.contactInfo} />
      </Section>
    </div>
  )
})
